'use strict';

var React = require('react');

var SvgDecimalMinor = function SvgDecimalMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.986 4.165a1 1 0 1 0-1.972-.33l-.361 2.165h-3.973l.306-1.835a1 1 0 1 0-1.972-.33l-.361 2.165h-2.653a1 1 0 1 0 0 2h2.32l-.667 4h-1.653a1 1 0 1 0 0 2h1.32l-.306 1.836a1 1 0 0 0 1.972.329l.361-2.165h3.972l-.305 1.836a1 1 0 0 0 1.972.329l.361-2.165h2.653a1 1 0 0 0 0-2h-2.32l.667-4h1.653a1 1 0 1 0 0-2h-1.32l.306-1.835Zm-7.306 7.835.667-4h3.972l-.666 4h-3.973Zm10.32 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

exports.SvgDecimalMinor = SvgDecimalMinor;
